import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ThemeProvider } from '@mui/material/styles'

import { materialTheme } from '@/styles/material-theme'
import { constants } from './datatable.constant'
import Datatable from './Datatable'
import { getStore, makeStore } from './store'

export const renderDatatable = (init = true) => {
	const targets = document.querySelectorAll(`[${constants.selector.datatable}]`)

	for (let i = 0, { length } = targets; i < length; i++) {
		const target = targets[i]
		const endpoint = target.getAttribute(constants.selector.endpoint)
		if (!endpoint) {
			console.warn('DynamicTable missing request endpoint!')
			continue
		}

		if (init) {
			makeStore(endpoint)
		}

		ReactDOM.render(
			<Provider store={getStore(endpoint)}>
				<ThemeProvider theme={materialTheme}>
					<Datatable endpoint={endpoint} exist={Array.from(target.childNodes).length > 0} />
				</ThemeProvider>
			</Provider>,
			target,
		)
	}
}
